import { Injectable } from '@angular/core'
import { EnforcementWhiteList } from '../models/enforcement-control.model'
import { finalize, map, Observable, of } from 'rxjs'
import { StoreState } from '../../../../store/store.state'
import { Store } from '@ngrx/store'
import { ApiService } from '../../../../core/services/api/api.service'
import { HideLoading, ShowLoading } from '../../../../store/loading/loading.actions'
import { UserService } from '../../../../core/services/user.service'
import { GettingStartedInteractionsAnnotations } from '../../../../shared/models/getting-started/getting-started-interactions.model'

@Injectable({providedIn: 'root'})
export class EnforcementWlService {

  constructor(
    private apiService: ApiService,
    private store: Store<StoreState>,
    private userService: UserService,
  ) { }
  
  updateEnforcementWhitelist(wl: EnforcementWhiteList): Observable<EnforcementWhiteList> {
    this.store.dispatch(new ShowLoading('EnforcementWLUpdate'))
    return this.apiService.patch('/v1/me', {
      interactions: {
        e: wl
      }
    }).pipe(
      finalize(() => this.store.dispatch(new HideLoading('EnforcementWLUpdate')))
    )
  }

  updateAnnotationsEnabled(value: GettingStartedInteractionsAnnotations): Observable<any> {
    this.store.dispatch(new ShowLoading('AnnotationsUpdate'))
    return this.apiService.patch('/v1/me', {
      interactions: {
        annotations: value
      }
    }).pipe(
      finalize(() => this.store.dispatch(new HideLoading('AnnotationsUpdate')))
    )
  }

}